class Token {
    value: string
    expEpochSeconds: number
    constructor(value: string, expEpochSeconds: number) {
        this.value = value
        this.expEpochSeconds = expEpochSeconds
    }
    isValid = () => {
        if (this.value.length === 0) return false

        const currentEpochDateSeconds = Math.floor(Date.now() / 1000)

        return currentEpochDateSeconds < this.expEpochSeconds
    }
}

export default Token
